import { render, staticRenderFns } from "./aliBeyEditor.vue?vue&type=template&id=04f64d49&scoped=true"
import script from "./aliBeyEditor.vue?vue&type=script&lang=js"
export * from "./aliBeyEditor.vue?vue&type=script&lang=js"
import style0 from "./aliBeyEditor.vue?vue&type=style&index=0&id=04f64d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f64d49",
  null
  
)

export default component.exports